import React from 'react'
type Props = {
  size: number // px or rem ...
  color: string
  className?: string
}

export const LinkedinIcon = ({
  size,
  color,
  className,
}: Props): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M29.613 0h-25.6a3.2 3.2 0 00-3.2 3.2v25.6a3.2 3.2 0 003.2 3.2h25.6a3.2 3.2 0 003.2-3.2V3.2a3.2 3.2 0 00-3.2-3.2zm-22.4 7.302a2.505 2.505 0 005.011 0 2.506 2.506 0 00-5.01 0zM7.614 25.6h4.299V11.782H7.614V25.6zm20.4 0h-4.296v-6.72c0-1.603-.03-3.664-2.234-3.664-2.236 0-2.58 1.746-2.58 3.548V25.6h-4.296V11.782h4.124v1.888h.058c.574-1.086 1.976-2.232 4.067-2.232 4.352 0 5.157 2.862 5.157 6.583V25.6z'
        fill={color}
      />
    </svg>
  )
}

export const FacebookIcon = ({
  size,
  color,
  className,
}: Props): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M28.8 0H3.2A3.2 3.2 0 000 3.2v25.6A3.2 3.2 0 003.2 32H16V19.953h-4.8v-4.518H16V13.01C16 8.416 18.384 6.4 22.28 6.4c1.83 0 2.814.13 3.292.194l.028.003v4.32h-2.658c-1.654 0-2.142.856-2.142 2.588v1.93h4.758l-.657 4.518H20.8V32h8a3.2 3.2 0 003.2-3.2V3.2A3.2 3.2 0 0028.8 0z'
        fill={color}
      />
    </svg>
  )
}

export const InstagramIcon = ({
  size,
  color,
  className,
}: Props): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.82 0h12.8a9.6 9.6 0 019.6 9.6v12.8a9.6 9.6 0 01-9.6 9.6H9.82a9.6 9.6 0 01-9.6-9.6V9.6A9.6 9.6 0 019.82 0zm16 4.8c.8 0 1.6.8 1.6 1.6s-.8 1.6-1.6 1.6-1.6-.8-1.6-1.6.8-1.6 1.6-1.6zM24.22 16c0-4.412-3.587-8-8-8-4.411 0-8 3.588-8 8s3.589 8 8 8c4.413 0 8-3.588 8-8zm-8-4.8a4.8 4.8 0 100 9.6 4.8 4.8 0 000-9.6z'
        fill={color}
      />
    </svg>
  )
}

export const EFIcon = ({ size, color, className }: Props): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M29.206 0h-25.6a3.2 3.2 0 00-3.2 3.2v25.6a3.2 3.2 0 003.2 3.2h25.6a3.2 3.2 0 003.2-3.2V3.2a3.2 3.2 0 00-3.2-3.2zm-7.619 19.69v-8.815h-2.422V8.898l2.422-.353V6.644a5.32 5.32 0 01.17-1.524c.078-.227.176-.446.29-.655.096-.186.224-.352.376-.491.147-.164.314-.308.497-.429a3.443 3.443 0 011.695-.34 8.7 8.7 0 012.737.504h.254v1.587H24.99c-.83 0-.926.376-.965.527l-.003.015c-.032.339-.032.68 0 1.02v1.498h2.422v2.519h-2.422v8.815h-2.435zM6.304 26.957c.932 1.308 2.465 1.999 4.02 1.813a25.95 25.95 0 007.376-.818h.254v-2.318h-.34c-2.222.259-4.46.364-6.696.315a2.6 2.6 0 01-2.156-.73 6.107 6.107 0 01-.581-2.997h5.68c2.724 0 4.117-1.26 4.117-3.778a9.751 9.751 0 00-.52-3.438 3.385 3.385 0 00-1.575-1.726 9.037 9.037 0 00-3.96-.642 11.674 11.674 0 00-3.815.504c-.506.177-.964.48-1.332.881-.372.436-.671.934-.884 1.474a16.739 16.739 0 00-.654 5.642 11.725 11.725 0 001.066 5.818zm8.72-8.526c0 .491-.146 1.26-1.442 1.26l-5.377-.013c-.03-.8.044-1.6.218-2.38l.04-.142c.074-.269.155-.558.226-.74a.912.912 0 01.364-.453c.155-.118.321-.22.496-.302a2.48 2.48 0 01.666-.14c.327-.075.594-.075.812-.075h1.21c.47-.002.94.027 1.406.088.316.05.614.19.86.403.223.213.373.496.423.807.081.558.114 1.123.097 1.687z'
        fill={color}
      />
    </svg>
  )
}
